import React from "react";
import { FaImage } from "react-icons/fa";

/**
 * Katalog listelerinde parça/makine görselinin küçük önizlemesi.
 * Görseli olmayan kayıtta yer tutucu gösterilir — satır yükseklikleri
 * kaymasın diye kutu her zaman aynı boyutta kalır.
 */
const CatalogThumb = ({ src, alt = "", size = "sm" }) => {
  const box = size === "md" ? "w-10 h-10" : "w-8 h-8";

  return (
    <span
      className={`${box} shrink-0 inline-flex items-center justify-center rounded-md border border-gray-200 bg-gray-50 overflow-hidden`}
    >
      {src ? (
        <img src={src} alt={alt} className="w-full h-full object-cover" />
      ) : (
        <FaImage className="text-gray-300 text-xs" />
      )}
    </span>
  );
};

export default CatalogThumb;
